let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfs7N")).then(() => parcelRequire('bqTTp'));